import { gsap } from 'gsap';
import focusLock from 'dom-focus-lock';
import { getScrollbarWidth } from '../function/getScrollBarWidth';
import { closeHeaderSearch } from './headerSearch';

const ulToExpandId = "ulMobile";
const ulChildToExpandId = "ulChildMobile";
const topMenuButtonMobileId = "topMenuButtonMobile";
const spanMobileId = "spanMobileId"
const navigationIconMobileParentId = "navigationIconMobileParent"
const body: HTMLElement = document.body;
const menu: HTMLElement = document.getElementById('menu');
const menuButton: HTMLElement = document.getElementById('menu-button');
const closeButton: HTMLElement = document.getElementById('header-menu-close');
const primaryNavigation = menu.querySelectorAll('.primary-navigation li');
const header: HTMLElement = document.getElementById('header');
const allUlsToExpand = document.querySelectorAll(`[id^=${ulToExpandId}]`);
const allChildUlsToExpand = document.querySelectorAll(`[id^=${ulChildToExpandId}]`);
const allMobileButtons = document.querySelectorAll(`[id^=${topMenuButtonMobileId}]`);
const allMobileSpans = document.querySelectorAll(`[id^=${spanMobileId}]`);
const allNavigationIconsMobileParents = document.querySelectorAll(`[id^=${navigationIconMobileParentId}]`);
const alltopMenuIconUpMobileParent = document.querySelectorAll(`[id^=topMenuIconUpMobileParent`);
const backToFirstPage: HTMLElement = document.getElementById('backFirstPageButton');
const backPage: HTMLElement = document.getElementById('backPageButton');
const language = document.getElementById("language");
const selectedLanguage = document.getElementById("selectedLanguage");

function hideSpans(item) {
    if (item.classList.contains('buttonSpanMarkedTopLevel')) {
        item.classList.remove('buttonSpanMarkedTopLevel');
    }
}

function hideUls(item) {
    if (item.classList.contains('ulMarked')) {
        item.classList.remove('ulMarked');
    }
    item.style.display = 'none';
}

function hideExitIcon() {
    const menuIcon = document.getElementById('MenuIcon');
    const exitIcon = document.getElementById('ExitIcon');

    if (menuIcon && exitIcon) {
        menuIcon.classList.remove('hide');
        exitIcon.classList.add('hide');
    }
}
function showAllButtons(item) {
    item.style.display = 'inline-flex';
}

const escapeEvent = (event) => {
    if (event.defaultPrevented) {
        return;
    }
    const key = event.key || event.keyCode;

    if (key === 'Escape' || key === 'Esc' || key === 27) {
        closeNavigation();
    }
};

export const closeNavigation = function () {
    allUlsToExpand.forEach(hideUls);
    allChildUlsToExpand.forEach(hideUls);
    allMobileSpans.forEach(hideSpans);
    allMobileButtons.forEach(showAllButtons);

    allMobileButtons.forEach((button: HTMLButtonElement) => {
        button.disabled = false;
    });

    if (language !== null) {
        language.style.display = "none";
    }

    if (selectedLanguage !== null) {
        selectedLanguage.style.display = "flex";
    }

    allNavigationIconsMobileParents.forEach((item: HTMLElement) => {
        item.style.display = 'block';
    });

    alltopMenuIconUpMobileParent.forEach((item: HTMLElement) => {
        item.style.display = 'none';
    });

    if (backToFirstPage !== null) {
        backToFirstPage.classList.remove('hide');
    }

    if (backPage !== null) {
        backPage.classList.add('hide');
    }
    hideExitIcon();
    gsap.to(primaryNavigation, { y: -20, opacity: 0, duration: 0.05, stagger: -0.025 });
    gsap.to(menu, {
        duration: 0,
        delay: 0,
        y: '-100%',
        transformOrigin: 'top',
        ease: 'expo.inOut',
        onComplete: () => {
            header.classList.remove('elevate');
            menu.classList.remove('header__main-menu--open');
            menuButton.setAttribute('aria-expanded', 'false');
            menuButton.classList.remove('menu-toggle--open');
            menu.removeEventListener('keyup', escapeEvent);
            body.classList.remove('no-scroll');
            focusLock.off(menu);
            menuButton.focus();
        },
    });
};

(function () {

    if ('undefined' === typeof menuButton || !menu) {
        return;
    }

    closeButton.onclick = function () {
        closeNavigation();
    };

    if (backToFirstPage !== null) {
        backToFirstPage.onclick = function () {
            closeNavigation();
        }
    }

    if (backPage !== null) {
        backPage.onclick = function () {
            allUlsToExpand.forEach(hideUls);
            allChildUlsToExpand.forEach(hideUls);
            allMobileSpans.forEach(hideSpans);
            allMobileButtons.forEach(showAllButtons);
            allNavigationIconsMobileParents.forEach((item: HTMLElement) => {
                item.style.display = 'block';
            });

            backToFirstPage.classList.remove('hide');
            backPage.classList.add('hide');

            if (language !== null) {
                language.style.display = "none";
            }

            if (selectedLanguage !== null) {
                selectedLanguage.style.display = "flex";
            }

            allMobileButtons.forEach((button: HTMLButtonElement) => {
                button.disabled = false;
            });
        }
    }

    function showExitIcon() {
        const menuIcon = document.getElementById('MenuIcon');
        const exitIcon = document.getElementById('ExitIcon');
        if (menuIcon && exitIcon) {
            menuIcon.classList.add('hide');
            exitIcon.classList.remove('hide');
        }
    }

    menuButton.onclick = function () {
        if (menu.classList.contains('header__main-menu--open')) {
            closeNavigation();
        } else {
            closeHeaderSearch();
            showExitIcon()
            const scrollbarWidth = getScrollbarWidth();
            document.body.style.setProperty('--scrollbar-width', scrollbarWidth.toString() + 'px');
            body.classList.add('no-scroll');

            menu.classList.add('header__main-menu--open');
            menuButton.setAttribute('aria-expanded', 'true');
            header.classList.add('elevate');

            gsap.set(primaryNavigation, { y: -20, opacity: 0 });
            menu.classList.add('header__main-menu--open');
            menuButton.setAttribute('aria-expanded', 'true');

            gsap.to(menu, {
                duration: 0,
                y: 0,
                transformOrigin: 'top',
                ease: 'expo.inOut',
                onComplete: () => {
                    gsap.to(primaryNavigation, {
                        y: 0,
                        opacity: 1,
                        duration: 0,
                        stagger: 0,
                        onComplete: () => {
                            menu.focus();
                            focusLock.on(menu);
                        },
                    });
                },
            });

            menu.addEventListener('keyup', escapeEvent);
        }
    };
})();